import Instafeed from 'instafeed.js'

export default {
  init() {
    var feed = new Instafeed({
      accessToken: '3137605396.d081ca8.4ff01abc17554762883ec8a19527e903',
      userId: '3137605396',
      get: 'user',
      sortBy: 'most-recent',
      resolution: 'standard_resolution',
      limit: 9,
      template: '<div class="insta-item" style="background-image: url({{image}})"><a href="{{link}}" target="_blank">&nbsp;</a></div>',
    });
    feed.run();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/agentur.js